import {isEmpty, toPairs} from 'lodash/fp'

export function makeEvery<T, P>(callback: (item: T, findItem: P) => boolean): (findList: P[], array: T[]) => boolean {
    return (findList: P[], array: T[]) => {
        return findList.every((findItem) => {
            return array.some((item) => callback(item, findItem))
        })
    }
}

/** 주어진 목록이 리스트에 모두 존재하는지 확인합니다 */
export const hasEvery = makeEvery<string, string>((item, findItem) => item === findItem)

/** 주어진 목록에 리스트 목록중 하나라도 존재하는지 확인합니다 */
export function hasSome<T>(list1: T[]): (list: T[]) => boolean {
    return (list2: T[]): boolean => {
        if (isEmpty(list1) || isEmpty(list2)) {
            return false
        }
        return list2.some((payMethod) => {
            return list1.includes(payMethod)
        })
    }
}

export const toPairsWithType = <T>(source: T): Array<[keyof T, T[keyof T]]> =>
    toPairs(source as unknown as object) as [keyof T, T[keyof T]][]

export const includeList = <T, Check>({
    checks,
    list,
    callback,
}: {
    checks: Check[]
    list: T[]
    callback?: (item: T) => Check
}) => {
    return list.reduce<boolean[]>(
        (acc, item) => {
            return checks.map((check, idx) => {
                return acc[idx] || (callback?.(item) ?? item) === check
            })
        },
        checks.map(() => false),
    )
}

/** 배열에 중복을 제거하는 함수 */
export function omitDuplicationList<T>(list: T[]): T[] {
    const result = new Set()

    list.forEach((a) => {
        result.add(a)
    })

    return [...result.values()] as T[]
}

/** 배열 합쳐 중복을 제거하는 함수 */
export function concatDuplicationList<T>(listA: T[], listB: T[]): T[] {
    return omitDuplicationList([...listA, ...listB])
}
